import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";
import { useProject } from "../project";

export function useDeleteDeliverableMutation(workstreamId: string, deliverableId: string) {
    const { project } = useProject();
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async () => {
            await apiClient.deleteDeliverable({
                params: { projectId: project.id, workstreamId, deliverableId },
            });
            await queryClient.refetchQueries({ queryKey: ["project", project.id] });
        },
    });
}
